import {connect} from 'react-redux';
import React from 'react';

import UserModel from '/app/src/model/User/model';

import ConversationSelector from '/app/src/model/Conversation/selector';
import CustomerSelector from '/app/src/model/Customer/selector';
import EntrySelector from '/app/src/model/Entry/selector';

import ConversationPreview from './Conversation'
import {SVGButton} from '/app/src/component'

class PreviewUnassigned extends React.Component {
    __claimButtonClick(room) {
        return () => {
            this.props.dispatch(UserModel.claimingTicket(room));
        }
    }

    render() {
        const {room, customerIsOnline, imageUrl, conversation,
        isTyping, entry, currentRoom, exchange} = this.props

        let unread = ConversationSelector.getUnread(conversation, 0);
        let entryBody =  EntrySelector.body(entry);
        let entryDateCreated = EntrySelector.detailsDateCreated(entry);

        return (
            <ConversationPreview
                conversation={conversation}
                room={room}
                currentRoom={currentRoom}
                title={this.props.customerName}
                imageUrl={imageUrl}
                entryBody={entryBody}
                entryDateCreated={entryDateCreated}
                isOnline={customerIsOnline}
                isTyping={isTyping}
                unread={unread}
                exchange={exchange}
            >
                <SVGButton
                    text='Svara'
                    color='lightgrey' border
                    src='/images/ErrandTransfer_M.svg'
                    hover='blue'
                    onClick={this.__claimButtonClick(room)}
                />
            </ConversationPreview>
        );

    }

}

function mapStateToProps(state, ownProps){
    let conversation = ConversationSelector.getByRoom(state, ownProps.room)
    let customerId = ConversationSelector.getCustomerId(conversation)
    let customer = CustomerSelector.byId(state, customerId)
    let customerName = CustomerSelector.getName(customer)
    let customerIsOnline;
    const isTyping = ConversationSelector.getIsTyping(state, ownProps.room);

    if(customer){
        customerIsOnline = customer.getIn(['info', 'payload', 'is_online']);
    }

    let entry = ConversationSelector.lastEntry(conversation);
    return {
        conversation,
        entry,
        exchange: ConversationSelector.getExchange(conversation),
        customer,
        customerId,
        customerName,
        customerIsOnline,
        isTyping
    }


}

export default connect(mapStateToProps)(PreviewUnassigned);



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/UnassignedContainer.js